// @flow
/**
 * Created by Mike Chung on 2/9/18.
 */

import type {SsoUserQueryCriteria} from "../../../model/sso/SsoUserQueryCriteria";
import type {SsoUserQueryFailedAction, SsoUserQueryStartAction, SsoUserQuerySuccessAction, SsoUserQueryThunkAction} from "../ssoUserQueryAction";
import SsoUser from "../../../model/sso/SsoUser";
import {findSsoUserByCriteria} from "../../../dao/ssoUserDao";
import type {Caller} from "../../../components/QueryPage";
import type {StoreState} from "../../../reducers/combinedReducers";

function ssoUserQueryStartAction(criteria: SsoUserQueryCriteria): SsoUserQueryStartAction {
    return {
        type: "sso/QUERY_START_ACTION",
        criteria: Object.assign({}, criteria)
    };
}

export function ssoUserQuerySuccessAction(ssoUsers: Array<SsoUser>, totalResult: number): SsoUserQuerySuccessAction {
    return {
        type: "sso/QUERY_SUCCESS_ACTION",
        ssoUsers: [].concat(ssoUsers),
        totalResult: totalResult
    }
}

function ssoUserQueryFailedAction(error: any): SsoUserQueryFailedAction {
    return {
        type: "sso/QUERY_FAILED_ACTION",
        error: Object.assign({}, error)
    }
}

export function ssoUserQueryAction(criteria: SsoUserQueryCriteria, caller: Caller): SsoUserQueryThunkAction {

    return async (dispatch, getState: ?() => StoreState) => {

        try {

            if (getState) {

                dispatch(ssoUserQueryStartAction(criteria));
                let ssoUserQueryResult = await findSsoUserByCriteria(criteria, caller, getState().loginUser.jwt);
                dispatch(ssoUserQuerySuccessAction(ssoUserQueryResult.result, ssoUserQueryResult.totalResult));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            dispatch(ssoUserQueryFailedAction(e));
        }

    };
}


// WEBPACK FOOTER //
// ./src/actions/sso/creators/ssoUserQueryActionCreator.js